import { PORTAL_AUTOMATION_API_NAME, PORTAL_AUTOMATION_ROUTES } from './constants';
import WorkflowListPage from './WorkflowListPage';

// Portal-automation runs are integration-created, so no New button.
export default function PortalAutomationListPage() {
  return (
    <WorkflowListPage
      title='Portal Automation'
      apiName={PORTAL_AUTOMATION_API_NAME}
      basePath={PORTAL_AUTOMATION_ROUTES.BASE}
    />
  );
}
